export const brand = {
  primary: "#c09ee0",
  navy: "#823DC2",
  orange: "#823DC2",
  blue: "#823DC2",
  white: "#FFFFFF",
};

export const chartPalette = [
  "#823DC2",
  "#823DC2",
  "#823DC2",
  "#7F8CFF",
  "#FFB680",
];
